/*
 * VersandanweisungenCard.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-16 in huWaWi3 33.10.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { ReactNode } from 'react'
import * as React from 'react'

import { LinkRender } from '../../lib/hd-link'
import { HdCard } from '../components/HdCard'

export function VersandanweisungenCard({ anweisungen }) {
  const text: ReactNode[] = []
  const flags: ReactNode[] = []
  const versandanweisungen = anweisungen
  // Kommentar hier klappt was nicht, timing ding?

  if (!(anweisungen?.length > 1)) {
    return null
  } else {
    // Die erste Versandanweisung ist automatisch die "zusammengetackerte"
    const va = versandanweisungen[0]
    if (va.avisieren_tage) {
      flags.push(<>{`${va.avisieren_tage} Tage vorher avisieren`}</>)
    }
    if (va.hebebuehne) {
      flags.push(<>Anliefern mit Hebebühne</>)
    }
    if (va.versandart_unfrei) {
      flags.push(<>Versandart "unfrei"</>)
    }
    if (va.ccg_i) {
      flags.push(<>Abpacken auf CCGI</>)
    }

    if (va.avisieren_unter && va.avisieren_unter !== '') {
      text.push(
        <>
          <dt>Avisieren bei</dt>
          <dd>{va.avisieren_unter}</dd>
        </>
      )
    }
    if (va.selbstabholer && va.selbstabholer !== '') {
      text.push(
        <>
          <dt>Selbstabholer</dt>
          <dd>va.selbstabholer</dd>
        </>
      )
    }
    if (va.info_lager && va.info_lager !== '') {
      text.push(
        <>
          <dt>Lagerinfo</dt>
          <dd>{va.info_lager}</dd>
        </>
      )
    }
    if (va.info_spediteur && va.info_spediteur !== '') {
      text.push(
        <>
          <dt>Speditionsinfo</dt>
          <dd>{va.info_spediteur}</dd>
        </>
      )
    }
    if (va.refs && va.refs.length > 0) {
      text.push(
        <>
          <dt>Versandanweisungs№</dt>
          <dd>
            {va.refs.map((x) => (
              <React.Fragment>
                <LinkRender key={x} value={x} />{' '}
              </React.Fragment>
            ))}
          </dd>
        </>
      )
    }
  }

  if (text.length === 0 && flags.length === 0) {
    return null
  }

  if (flags.length > 0 || text.length > 0) {
    return (
      <HdCard title={'Versandanweisungen'}>
        <ul>
          {flags.map((x, i) => (
            <li key={i}>{x}</li>
          ))}
        </ul>
        <dl>
          {text.map((x, i) => (
            <React.Fragment key={i}>{x}</React.Fragment>
          ))}
        </dl>
      </HdCard>
    )
  }
}
